import Image from 'next/image'
import React from 'react'

import useFlags from '@/legacy-src/hooks/useFlags'

const PaymentOptionsFooter: React.FC = () => {
  const { hidePaypal, allowKlarnaTransfer } = useFlags()
  return (
    <div className="flex flex-wrap">
      <Image src={`/images/footer/visa-rebrand.svg`} alt="Visa" width="58" height="20" className="mb-4 mr-5" />
      <Image
        src={`/images/footer/mastercard-rebrand.svg`}
        alt="Mastercard"
        width="32"
        height="20"
        className="mb-4 mr-5"
      />
      <Image
        src={`/images/footer/googlePay-rebrand.svg`}
        alt="Google Pay"
        width="42"
        height="20"
        className="mb-4 mr-5"
      />
      <Image src={`/images/footer/applePay-rebrand.svg`} alt="Apple Pay" width="32" height="20" className="mb-4 mr-5" />
      {!hidePaypal && (
        <Image src={`/images/footer/payPal-rebrand.svg`} alt="PayPal" width="75" height="20" className="mb-4 mr-5" />
      )}
      {allowKlarnaTransfer && (
        <Image src={`/images/footer/klarna-rebrand.svg`} alt="Klarna" width="90" height="20" className="mb-4 mr-5" />
      )}
    </div>
  )
}

export default PaymentOptionsFooter
